import './styles/SelectInputField.css';

import { PureComponent } from 'react';

import { isNullable } from '@ipfabric/utils';
import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import { FormInput } from 'components/FormInput/FormInput';
import get from 'lodash/get';

// type PropsType = {
//   anyValue?: boolean,
//   block?: boolean,
//   externalError?: string,
//   inputSize?: boolean,
//   isLoading: boolean,
//   onInputChange: Function,
//   onSelectFocus?: Function,
//   onSelectBlur?: Function,
//   wrapperClassName?: string,
//   autoTrim?: boolean,
//   validateIp?: boolean,
// };

// type StateType = {
//   input: string,
//   showMenu: boolean,
//   inputChanged: boolean,
// };

export default class SelectInputField extends PureComponent {
  static defaultProps = {
    anyValue: false,
    autoTrim: false,
    validateIp: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      inputValue: props.input.value || '',
      showMenu: false,
      inputChanged: false,
      focusedOption: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.input.value !== prevProps.input.value) {
      this.setState({ inputValue: this.props.input.value });
    }
  }

  getInputSize = () => {
    const { inputSize } = this.props;
    const DEFAULT_VALUE = 20;
    if (inputSize) {
      if (inputSize < DEFAULT_VALUE) {
        return DEFAULT_VALUE;
      }
      return inputSize;
    }
    return DEFAULT_VALUE;
  };

  getErrorMessage = () => {
    const {
      meta: { touched, error },
      externalError,
      msg,
    } = this.props;
    if (touched && error) {
      return get(msg, ['validation', error], 'Error');
    }
    return get(msg, ['validation', externalError], 'Error');
  };

  handleInputChange = (e) => {
    const { onInputChange, anyValue, input, autoTrim } = this.props;
    const value = autoTrim
      ? (e.target.value || '').trimStart()
      : e.target.value;
    this.setState({ inputValue: value, inputChanged: true });
    onInputChange(value);
    if (anyValue) {
      input.onChange(value);
    }
  };

  handleFocus = () => {
    const { onSelectFocus } = this.props;
    this.setState({ showMenu: true });
    if (typeof onSelectFocus === 'function') {
      onSelectFocus();
    }
  };

  handleBlur = () => {
    const { input, onSelectBlur, anyValue } = this.props;
    const { focusedOption, showMenu, inputChanged } = this.state;
    if (!showMenu || isNullable(focusedOption)) {
      this.setState(
        {
          showMenu: false,
          focusedOption: null,
          inputValue:
            inputChanged || anyValue ? input.value : this.state.inputValue,
        },
        () => {
          if (onSelectBlur) {
            onSelectBlur(this.state.inputValue);
          }
        },
      );
      if (inputChanged) {
        this.setState({ inputValue: input.value });
      }
    }
  };

  handleSelectValue = (option) => {
    const { input, onSelectBlur } = this.props;
    input.onChange(option.label);
    this.setState(
      { showMenu: false, focusedOption: null, inputValue: option.label },
      () => {
        if (onSelectBlur) {
          onSelectBlur(this.state.inputValue);
        }
      },
    );
  };

  handleFocusOption = (option) => {
    this.setState({ focusedOption: option });
  };

  handleUnfocusOption = () => {
    this.setState({ focusedOption: null });
  };

  render() {
    const {
      block,
      externalError,
      id,
      input,
      isLoading,
      menuRenderer,
      meta: { touched, error },
      options,
      placeholder,
      wrapperClassName,
    } = this.props;
    const { inputValue, showMenu, focusedOption } = this.state;
    return (
      <div
        className={classNames(
          wrapperClassName,
          block ? 'block' : 'inline-block',
          'relative',
        )}
      >
        <div className='Select select-input-field' name={input.name}>
          <FormInput
            className='form-control'
            hasError={(touched && error) || externalError}
            id={id}
            onBlur={this.handleBlur}
            onChange={this.handleInputChange}
            onFocus={this.handleFocus}
            placeholder={placeholder}
            size={this.getInputSize()}
            type='text'
            value={inputValue}
          />
          {isLoading ? (
            <i className='fa fa-circle-o-notch fa-spin select-input-field__spinner' />
          ) : null}
          {showMenu && !isLoading
            ? menuRenderer({
                options,
                focusedOption,
                onSelectValue: this.handleSelectValue,
                onFocusOption: this.handleFocusOption,
                onUnfocusOption: this.handleUnfocusOption,
              })
            : null}
        </div>
        {(touched && error) || externalError ? (
          <FormErrorMessage>{this.getErrorMessage()}</FormErrorMessage>
        ) : null}
      </div>
    );
  }
}
